import Axios from 'config/service.config'
import { setAuthCookies } from 'utils/auth'

export const getToken = async ({ email, password }) => {
  try {
    const payload = { email: email }
    window.localStorage.setItem('password', password)
    window.localStorage.setItem('email', email)
    return await Axios.post('/authenticate/send-access-key', payload)
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const sendKeyCode = async ({ keyCode, isNewsletterOptIn, email, password, authenticationToken }) => {
  try {
    const payload = {
      email: email,
      password: password || window.localStorage.getItem('password'),
      authenticationToken: authenticationToken || window.localStorage.getItem('registryToken'),
      accessKey: keyCode,
      optinNewsLetter: isNewsletterOptIn
    }

    if (!payload.email) {
      throw new Error('Um problema aconteceu ao salvar seu email, por favor tente novamente mais tarde.')
    }

    const { data } = await Axios.post('/authenticate/register', payload)
    setAuthCookies({
      authCookie: data.authCookie,
      accountAuthCookie: data.accountAuthCookie
    })
    window.localStorage.removeItem('password')
    window.localStorage.removeItem('registryToken')
    window.localStorage.removeItem('email')
    return data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const saveRegistryToken = (token) => {
  window.localStorage.setItem('registryToken', token)
}
